import { useEffect, useState } from "react";
import { externalApiHost, targetEnv } from "@/api";

/**
 * サインアップ可否を API から取得する
 *
 * External API の GET /service_state/signup/availability を呼び出します。
 * エラー時はフェイルクローズ（false）で動作します。
 * コンポーネント外（Authenticator services 等）からも利用可能です。
 *
 * NOTE: 現在は fetch で直接呼び出していますが、external-api のエンドポイントが
 * 増えた場合は OpenAPI クライアント（generatedApi）を生成して置き換えてください。
 */
export async function fetchSignupAvailability(): Promise<boolean> {
  try {
    const res = await fetch(`${externalApiHost[targetEnv]}/service_state/signup/availability`);
    if (!res.ok) return false;
    const data = await res.json();
    return data.available !== false;
  } catch {
    return false;
  }
}

type SignupAvailability = {
  isSignupAvailable: boolean;
  loading: boolean;
};

/**
 * サインアップ可否を取得するカスタムフック
 */
export const useSignupAvailability = (): SignupAvailability => {
  const [isSignupAvailable, setIsSignupAvailable] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchSignupAvailability().then((result) => {
      if (!cancelled) {
        setIsSignupAvailable(result);
        setLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { isSignupAvailable, loading };
};
